import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import {
	type GoalDetailResponseDTO,
	putGoalIdV2,
	type UpdateGoalRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type GoalPinPortfolioVariables = {
	id: number;
	body: UpdateGoalRequestDTO;
};

export const useGoalPinPortfolioMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<GoalDetailResponseDTO, Error, GoalPinPortfolioVariables>({
		mutationFn: processResponse(({ id, body }: GoalPinPortfolioVariables) =>
			putGoalIdV2(body, id),
		),
		onSuccess: (data, variables) => {
			queryClient.setQueryData<GoalDetailResponseDTO>(
				GoalsKeys.detail(variables.id),
				data,
			);
			queryClient.invalidateQueries({
				queryKey: GoalsKeys.detailPortfolios(),
			});
		},
	});
};
